export { default } from './DialogHeader';
export * from './DialogHeader';
